(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-calculadora-edad"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gb-calculadora')) {
    // Años humanos por año de vida (1–16), tabla orientativa de la AVMA.
    const TABLA = {
      p: [15, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80],
      m: [15, 24, 28, 32, 36, 42, 47, 51, 56, 60, 65, 69, 74, 78, 83, 87],
      g: [15, 24, 28, 32, 36, 45, 50, 55, 61, 66, 72, 77, 82, 88, 93, 99],
      c: [15, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80],
    };
    const PASO = { p: 4, m: 4.5, g: 5.5, c: 4 };

    class GbCalculadora extends HTMLElement {
      connectedCallback() {
        this.especie = this.querySelector('[data-especie]');
        this.edad = this.querySelector('[data-edad]');
        this.cifra = this.querySelector('[data-cifra]');
        this.etapa = this.querySelector('[data-etapa]');
        if (!this.especie || !this.edad || !this.cifra || !this.etapa) return;
        this.controlador = new AbortController();
        const opciones = { signal: this.controlador.signal };
        this.especie.addEventListener('change', () => this.calcular(), opciones);
        this.edad.addEventListener('input', () => this.calcular(), opciones);
        this.calcular(false);
      }

      disconnectedCallback() {
        this.controlador?.abort();
      }

      humanos(especie, anos) {
        const a = Math.max(1, Math.min(22, Math.round(anos) || 1));
        const tabla = TABLA[especie] || TABLA.m;
        return a <= 16 ? tabla[a - 1] : Math.round(tabla[15] + (a - 16) * (PASO[especie] || 4.5));
      }

      calcular(animar = true) {
        const h = this.humanos(this.especie.value, parseFloat(this.edad.value));
        let n = 4;
        if (h < 45) n = 1;
        else if (h < 60) n = 2;
        else if (h < 75) n = 3;
        if (this.cifra.textContent !== String(h)) {
          this.cifra.textContent = String(h);
          if (animar) {
            this.cifra.classList.remove('is-cambio');
            void this.cifra.offsetWidth;
            this.cifra.classList.add('is-cambio');
          }
        }
        this.etapa.textContent = this.dataset[`etapa${n}`] || '';
      }
    }
    customElements.define('gb-calculadora', GbCalculadora);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-guia-altura"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gb-guia-altura')) {
    class GbGuiaAltura extends HTMLElement {
      connectedCallback() {
        const datos = this.querySelector('[data-medidas]');
        this.rango = this.querySelector('[data-rango]');
        if (!datos || !this.rango) return;
        try {
          this.medidas = JSON.parse(datos.textContent).sort((a, b) => a.h - b.h);
        } catch {
          return;
        }
        if (!this.medidas.length) return;
        this.valor = this.querySelector('[data-valor]');
        this.cota = this.querySelector('[data-cota]');
        this.sofa = this.querySelector('[data-sofa]');
        this.escalera = this.querySelector('[data-escalera]');
        this.elegida = this.querySelector('[data-elegida]');
        this.porque = this.querySelector('[data-porque]');
        this.elegir = this.querySelector('[data-elegir]');
        this.maximo = Number(this.rango.max) || 70;
        this.controlador = new AbortController();
        this.rango.addEventListener('input', () => this.actualizar(), { signal: this.controlador.signal });
        this.actualizar();
      }

      disconnectedCallback() {
        this.controlador?.abort();
      }

      /** Píxeles por centímetro dentro del dibujo (deja sitio para el respaldo del sofá). */
      escala() {
        return (this.querySelector('.gb-altura__dibujo')?.clientHeight - 90 || 150) / this.maximo;
      }

      pintarEscalera(alto, escalones) {
        const px = this.escala();
        this.escalera.replaceChildren(
          ...Array.from({ length: escalones }, (_, i) => {
            const peldano = document.createElement('i');
            peldano.style.height = `${((alto * (i + 1)) / escalones) * px}px`;
            return peldano;
          })
        );
      }

      actualizar() {
        const cm = Number(this.rango.value);
        const texto = `${cm} cm`;
        this.valor.textContent = texto;
        this.cota.textContent = texto;
        this.sofa.style.height = `${cm * this.escala()}px`;

        const posibles = this.medidas.filter((m) => m.h <= cm + 2);
        const medida = posibles.length ? posibles[posibles.length - 1] : this.medidas[0];
        const escalones = Number((medida.nombre.match(/(\d+)\s*(?:escal|pelda)/i) || [])[1]) || 3;
        const diferencia = cm - medida.h;
        this.pintarEscalera(medida.h, escalones);

        if (diferencia > 12) {
          this.elegida.textContent = `Ninguna llega: le quedarían ${diferencia} cm por subir`;
          this.porque.textContent = this.dataset.mensajeAlto || '';
          this.elegir.hidden = true;
          return;
        }
        this.elegida.textContent = medida.nombre.includes(`${medida.h} cm`) ? medida.nombre : `${medida.nombre} (${medida.h} cm)`;
        this.porque.textContent =
          diferencia > 0
            ? `El último escalón queda ${diferencia} cm por debajo del asiento: sube sin estirarse.`
            : 'El último escalón queda a la altura del asiento.';
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('variant', medida.id);
        this.elegir.href = url.toString();
        this.elegir.hidden = false;
      }
    }
    customElements.define('gb-guia-altura', GbGuiaAltura);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
